var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-9.3 10.68) rotate(-7.89)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.43,35.68H38.18a2.49,2.49,0,0,0-2.5,2.5V67.43a2.49,2.49,0,0,0,2.5,2.5H67.43a2.5,2.5,0,0,0,2.5-2.5V38.18A2.5,2.5,0,0,0,67.43,35.68Zm-2.5,29.25H40.68V40.68H64.93ZM47.27,60.84H58.34a2.5,2.5,0,0,0,2.5-2.5V47.27a2.5,2.5,0,0,0-2.5-2.5H47.27a2.5,2.5,0,0,0-2.5,2.5V58.34A2.5,2.5,0,0,0,47.27,60.84Zm2.5-11.07h6.07v6.07H49.77Zm30.8,38.45v19.1a2.5,2.5,0,0,1-5,0V88.22a2.5,2.5,0,0,1,5,0ZM67.43,75.57H38.18a2.49,2.49,0,0,0-2.5,2.5v29.25a2.49,2.49,0,0,0,2.5,2.5H67.43a2.5,2.5,0,0,0,2.5-2.5V78.07A2.5,2.5,0,0,0,67.43,75.57Zm-2.5,29.25H40.68V80.57H64.93Zm44.89-26.75V88.22a2.49,2.49,0,0,1-2.5,2.5h-21a2.5,2.5,0,1,1,0-5h18.46V78.07a2.5,2.5,0,0,1,5,0Zm-2.5-42.39H78.07a2.5,2.5,0,0,0-2.5,2.5V67.43a2.5,2.5,0,0,0,2.5,2.5h29.25a2.49,2.49,0,0,0,2.5-2.5V38.18A2.49,2.49,0,0,0,107.32,35.68Zm-2.5,29.25H80.57V40.68h24.25Zm5,32.84a2.49,2.49,0,0,1-2.5,2.5H86.53a2.5,2.5,0,0,1,0-5h20.79A2.49,2.49,0,0,1,109.82,97.77ZM75.57,78.07a2.5,2.5,0,0,1,2.5-2.5h19.1a2.5,2.5,0,1,1,0,5H78.07A2.5,2.5,0,0,1,75.57,78.07ZM95.2,107.32a2.5,2.5,0,0,1-2.5,2.5H86.53a2.5,2.5,0,0,1,0-5H92.7A2.5,2.5,0,0,1,95.2,107.32Zm14.62,0a2.49,2.49,0,0,1-2.5,2.5h-6.16a2.5,2.5,0,0,1,0-5h6.16A2.49,2.49,0,0,1,109.82,107.32Z",
    fill: "#624DE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrPayment);
export default __webpack_public_path__ + "static/media/qr-payment.2b73628d80b4c0d397fe7ea7c67506ea.svg";
export { ForwardRef as ReactComponent };